export class CustomerContact {
    public id: number;
    public customerNumberId: number;
    public contactMethodTypeId: number;
    public customerContactValue: string;
    public isPreferredContactMethod: boolean;
    public isCorrespondenceEnabled: boolean;
    public isPrimary: boolean;
    public isInvalid: boolean;
    public phoneExtension: string;
    public inactivate: boolean;
    public updatedBy: string;
    public updatedDate: any;
    public viewId: number;
    public contactType: string;
}
